import warning from 'warning';

var FiasLogger =
/** @class */
function () {
  function FiasLogger() {}

  FiasLogger.warnings = {
    baseUrlOrApiIsRequired: 'property "baseUrl" or "api" is required',
    noBaseUrl: 'baseUrl is not specified',
    fetchError: 'fetch error'
  };

  FiasLogger.log = function (message, details) {
    warning(false, "[Fias] " + message + (details ? ": " + details : ""));
  };

  return FiasLogger;
}();

export { FiasLogger };